import AnalyticsEvent from './analytics-event';

export type QuantityCounterSource = 'catalog_card' | 'cart' | 'product_page' | 'product_drawer' | 'reorder_carousel' | 'smart_reorder';
export type QuantityCounterInteractionType = 'increment' | 'decrement' | 'freeform';

export interface QuantityCounterTrackingContext {
  source: QuantityCounterSource;
  productId?: number;
  brandId?: number;
}

export default class QuantityCounterInteractedEvent extends AnalyticsEvent {
  public readonly name = 'Quantity Counter Interacted';
  public properties: {
    source: QuantityCounterSource;
    interaction_type: QuantityCounterInteractionType;
    quantity: number;
    product_id?: number;
    brand_id?: number;
  };

  constructor(context: QuantityCounterTrackingContext, interactionType: QuantityCounterInteractionType, quantity: number) {
    super();
    this.properties = {
      source: context.source,
      interaction_type: interactionType,
      quantity,
      ...(context.productId !== undefined && { product_id: context.productId }),
      ...(context.brandId !== undefined && { brand_id: context.brandId }),
    };
  }
}
